/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Property_PriorityInputs */

const en_explorer_info_property_priority = /** @type {(inputs: Explorer_Info_Property_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority`)
};

const fr_explorer_info_property_priority = /** @type {(inputs: Explorer_Info_Property_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority`)
};

const de_explorer_info_property_priority = /** @type {(inputs: Explorer_Info_Property_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority`)
};

const it_explorer_info_property_priority = /** @type {(inputs: Explorer_Info_Property_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority`)
};

const ru_explorer_info_property_priority = /** @type {(inputs: Explorer_Info_Property_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority`)
};

const es_explorer_info_property_priority = /** @type {(inputs: Explorer_Info_Property_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority`)
};

const zh_cn2_explorer_info_property_priority = /** @type {(inputs: Explorer_Info_Property_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority`)
};

const ja_explorer_info_property_priority = /** @type {(inputs: Explorer_Info_Property_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority`)
};

const hi_explorer_info_property_priority = /** @type {(inputs: Explorer_Info_Property_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority`)
};

const pt_pt2_explorer_info_property_priority = /** @type {(inputs: Explorer_Info_Property_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority`)
};

/**
* | output |
* | --- |
* | "Priority" |
*
* @param {Explorer_Info_Property_PriorityInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_property_priority = /** @type {((inputs?: Explorer_Info_Property_PriorityInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Property_PriorityInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_property_priority(inputs)
	if (locale === "de") return de_explorer_info_property_priority(inputs)
	if (locale === "it") return it_explorer_info_property_priority(inputs)
	if (locale === "ru") return ru_explorer_info_property_priority(inputs)
	if (locale === "es") return es_explorer_info_property_priority(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_property_priority(inputs)
	if (locale === "ja") return ja_explorer_info_property_priority(inputs)
	if (locale === "hi") return hi_explorer_info_property_priority(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_property_priority(inputs)
	return en_explorer_info_property_priority(inputs)
});